import { createContext, useContext } from 'react';
import type { Role } from '../types';
import type { Route } from './route';
import type { Actor } from './DemoStore';

export interface Ui {
  route: Route;
  navigate: (next: Partial<Route>, options?: { replace?: boolean }) => void;
  role: Role;
  actor: Actor;
  notify: (text: string, tone?: 'warn') => void;
  showPlannedFeatureNotice: (title: string) => void;
  openChat: (prefill?: string, conversationId?: string) => void;
  startReview: (postId?: string, only?: string[]) => void;
  canApprove: boolean;
  canStop: boolean;
}

export const UiContext = createContext<Ui | null>(null);
export function useUi() {
  const value = useContext(UiContext);
  if (!value) throw new Error('useUi must be used inside UiCtx');
  return value;
}
